export { default as NAvatar, avatarProps } from './src/Avatar';
